import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Ескі HashRouter сілтемелері (/#/analytics) → /analytics, бетті қайта жүктемей.
if (window.location.hash.startsWith('#/')) {
  window.history.replaceState(null, '', window.location.hash.slice(1));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);